<template>
  <div class="getRegisterInfo">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
      @handleColumnChange="handleColumnChange"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 260px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelPerfReport.51h4zb87asw0')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87b7w0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87bk00')
              "
              :picker-options="pickerOptions"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.info_type"
              clearable
              filterable
              :placeholder="$t('Analysisreport.fb')"
              @change="search"
            >
              <el-option :label="$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg6zdk0')" value="0"></el-option>
              <el-option :label="$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg70900')" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width: 320px">
            <el-input
              v-model="filter.keyword"
              clearable
              :placeholder="$t('Analysisreport.fc')"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelPerfReport.51h4zb87em80")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>

    <el-dialog
      :title="popData.title"
      :visible.sync="popDataVisible"
      class="tan-binding"
      width="450px"
      :before-close="handleClose"
    >
      <div class="create">
        <p v-if="popData.type == 'info_type'">{{ popData.content }}</p>
        <template v-else>
          <el-form :model="popData" ref="popDataForm" label-width="100px">
            <el-form-item
              :label="$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg70uo0')"
              prop="staffer_branch"
              :rules="[{ required: true, message: $t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg71hw0') }]"
            >
              <el-input
                filterable
                clearable
                class="layout-select"
                v-model="popData.staffer_branch"
                style="width: 280px"
                :placeholder="$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg71hw0')"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">
          {{ $t("Admissioncue.ax") }}
        </el-button>
        <el-button @click="popDataVisible = false">{{$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg71n40')}} {{$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg71r00')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
import http from '../analysisreport'
export default {
  name: "analysisreport-getRegisterInfo",
  data() {
    return {
      popDataVisible: false,
      popData: {
        title: "",
        content: "",
        type: "",
        staffer_branch: "",
        scopeData: null
      },

      reportParams: {
        wayString: "getRegisterInfo", //传递到子组件的方法名称
        Title: this.$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg71u00'),
      },

      //筛选
      filter: {
        rang_time: "",
        starttime: "",
        endtime: "",
        coursetype_id: "", //班组
        info_type: "",
        keyword: "",
      },
      // 筛选的下拉列表
      filterList: {
        coursetypeList: [], //班组-下拉数据
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.filter.rang_time = [
      this.$Common.getMonthStartAndEnd(0)[0],
      this.$Common.getMonthStartAndEnd(0)[1],
    ];
    this.filter.starttime = this.filter.rang_time[0];
    this.filter.endtime = this.filter.rang_time[1];
    this.courseTypeRecruitApi();
  },
  mounted() {},
  watch: {
    popDataVisible(n) {
      if (!n) {
        this.$refs["popDataForm"].resetFields();
      }
    },
  },
  methods: {
    handleClose(done) {
      this.$confirm(this.$t("Admissioncue.cl"))
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    handleColumnChange(v1, v2, v3) {
      this.popData.type = v2.fieldstring;
      this.popData.scopeData = { ...v3 }
      if (v2.fieldstring == "info_type") {
        this.popData.title = this.$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg71x80');
        this.popData.content = this.$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg720g0');
      } else if (v2.fieldstring == "main_marketer") {
        this.popData.title = this.$t('Report.ControlAnalysis.EnrollmentComparisonDetailReport.5zloarg723o0');
        this.popData.content = "";
      }
      this.popDataVisible = true;
    },
    handleSubmit () {
      if (this.popData.type == 'info_type') {
        this.changeXzToKzApi()
      } else if (this.popData.type == "main_marketer") {
        this.$refs['popDataForm'].validate(v => {
          if (v) {
            this.changeStafferApi()
          } else {
            return;
          }
        }) 
      }
    },

    changeXzToKzApi () {
      http.changeXzToKzApi({
        info_id: this.popData.scopeData.info_id
      }).then(res => {
        const { code, msg } = res.data
        this.$message({
          type: code === 200 ? 'success' : 'error',
          message: msg
        })
        if (code === 200) {
          this.courseTypeRecruitApi();
        }
      })
    },
    changeStafferApi () {
      http.changeStafferApi({
        info_id: this.popData.scopeData.info_id,
        staffer_branch: this.popData.staffer_branch
      }).then(res => {
        const { code, msg } = res.data
        this.$message({
          type: code === 200 ? 'success' : 'error',
          message: msg
        })
        if (code === 200) {
          this.courseTypeRecruitApi();
        }
      })
    },


    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    //检索
    search() {
      this.filter.starttime = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.endtime = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.getRegisterInfo {
  // height: 100vh;
  font-size: 20px;
}
</style>
